import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import routes from 'app/routes';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import SubmitButton from 'components/Widgets/SubmitButton';

export default function Form({ initialValues, onSave }) {
  const formSchema = Yup.object().shape({
    company: Yup.string().required('Company is required'),
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required'),
    website: Yup.string().required('Website is required'),
    phone: Yup.string().required('Phone is required'),
  });

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={initialValues}
      onSubmit={onSave}
    >
      {({ isSubmitting }) => (
        <FormikForm noValidate="">
          <HorizontalTextField name="company" label="Company" required />

          <HorizontalTextField name="website" label="Website" required />

          <HorizontalTextField name="firstName" label="First Name" required />

          <HorizontalTextField name="lastName" label="Last Name" required />

          <HorizontalTextField name="email" type="email" label="Email" required />

          <HorizontalTextField name="phone" label="Phone" required />

          <HorizontalTextField name="jobTitle" label="Role" />

          <footer>
            <Link
              to={routes.affiliates.prospects.index}
              className="btn btn-outline-primary"
              disabled={isSubmitting}
            >
              Cancel
            </Link>

            <SubmitButton loading={isSubmitting}>
              Save
            </SubmitButton>
          </footer>
        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  onSave: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};
